import { useEffect } from "react";
import { useRawTable } from "../../hooks";

export default function Module_BoneMuscleCare_VillageCaseRegularRecordCompletionRate({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
}) {
  const { setTbData, renderTable } = useRawTable({
    setting: moduleData,
    nullTransfer: "-",
  });

  useEffect(() => {
    if (!apiData) return;

    setTbData({
      raw: apiData.map((item) => ({
        ...item,
        執行率:
          item["實際完成數"] && item["應訪視追蹤數"]
            ? `${
                Math.round(
                  (item["實際完成數"] / item["應訪視追蹤數"]) * 10000
                ) / 100
              }%`
            : "0%",
      })),
      format: null,
      export: null,
    });
  }, [apiData]);

  return (
    <>
      {renderTable({
        moduleTitle: moduleData.label,
      })}
    </>
  );
}
